<script setup lang="ts">
import Icons from './Icons.vue';

// Emits の定義
const emit = defineEmits<{
    click: [event: MouseEvent];
}>();

// クリックハンドラー
const handleClick = (event: MouseEvent) => {
    // 企業情報ページへの遷移
    navigateTo('/company');

    // 親コンポーネントにクリックイベントを通知
    emit('click', event);
};
</script>

<template>
    <div class="card-service" @click="handleClick">
        <!-- コンテンツエリア -->
        <div class="card-service_content">
            <!-- タイトル -->
            <h3 class="card-service_title">
                企業情報
            </h3>

            <!-- リンクアイコン -->
            <Icons name="chevron-right" class="card-service_icon" />
        </div>
    </div>
</template>

<style scoped lang="scss">
// モバイル用のスタイル
.card-service {
    position: relative;
    margin: auto;
    overflow: hidden;
    cursor: pointer;
    width: 21.438rem; // 343px
    height: 12.5rem; // 200px
    min-width: 10.219rem; // 163.5px
    max-width: 30rem; // 480px
    min-height: 6rem; // 95.335px
    max-height: 17rem; // 279.883px
    border-radius: 1rem; // 16px
    opacity: 1;
    box-shadow: 0rem 0rem 0.5rem 0rem rgba(0, 0, 0, 0.16);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 43.1%, rgba(255, 255, 255, 0.90) 72.41%), url('~/assets/images/corporateCard.jpg') lightgray 50% / cover no-repeat;
    // 画面遷移のためのクリックイベント
    transition: all 0.3s ease;
}

// コンテンツエリア
.card-service_content {
    display: flex;
    justify-content: space-between;
    position: absolute;
    box-sizing: border-box;
    padding: 1rem; // 16px
    bottom: 0;
    left: 0;
    width: 100%;
}

// タイトル
.card-service_title {
    color: #2174C0;
    font-family: 'Noto Sans JP', sans-serif;
    font-weight: 700;
    font-size: 1.125rem; // 18px
    line-height: 150%;
    margin: 0;
    text-shadow: 0rem 0.125rem 0.25rem rgba(255, 255, 255, 0.8); // テキストを読みやすくする
}

// アイコン
.card-service_icon {
    align-self: flex-end;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem; // 24px
    height: 1.5rem; // 24px
    border: 0.063rem solid #2174C0; // 1px
    border-radius: 50%;
}

// デスクトップ用のスタイル
@include mixin.media(pc) {
    .card-service {
        width: 30rem; // 480px;
        height: 17.5rem; // 280px
        max-width: 30rem; // 480px;
        max-height: 17.5rem; // 280px;

        // ホバーエフェクト
        &:hover {
            box-shadow: none;
            opacity: 0.5;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 43.1%, rgba(255, 255, 255, 0.90) 72.41%), url('~/assets/images/corporateCard.jpg') lightgray 50% / cover no-repeat;
        }
    }
}

// 中間サイズ（512px以上750px未満）
$breakpoint-mobile: 512px;
$breakpoint-pc: 750px;
@media (min-width: $breakpoint-mobile) and (max-width: #{$breakpoint-pc - 1px}) {
    .card-service {
        width: 30rem; // 480px;
        height: 17.5rem; // 280px
        max-width: 30rem; // 480px;
        max-height: 17.5rem; // 280px;
    }
}
</style>
